import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AuditEntityType, AuditLogEntry } from '@catalyst-psa/shared';

import { api } from '../../api/client.js';

export const auditKeys = {
  all: ['audit-log'] as const,
  entity: (entityType: AuditEntityType, entityId: string) =>
    ['audit-log', entityType, entityId] as const,
};

/**
 * Fetches the change history for a single entity. Disabled until an id is available and
 * (optionally) the History tab is active, so the request only fires when shown.
 */
export function useAuditLog(
  entityType: AuditEntityType,
  entityId: string | null | undefined,
  enabled = true,
): UseQueryResult<AuditLogEntry[]> {
  return useQuery({
    queryKey: auditKeys.entity(entityType, entityId ?? ''),
    queryFn: () =>
      api.get<AuditLogEntry[]>(
        `/audit-log?entityType=${entityType}&entityId=${encodeURIComponent(entityId ?? '')}`,
      ),
    enabled: enabled && Boolean(entityId),
    staleTime: 30_000,
  });
}
